var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.6_06-onboarding",
    transform: "translate(-132.000000, -265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(98.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(34.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.7,
    fill: "#FFFFFF",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.71,18.0425 C32.1,17.6525 32.1,17.0025 31.71,16.6325 L29.37,14.2925 C29,13.9025 28.35,13.9025 27.96,14.2925 L26.12,16.1225 L29.87,19.8725 M14,28.2525 L14,32.0025 L17.75,32.0025 L28.81,20.9325 L25.06,17.1825 L14,28.2525 Z",
    id: "Shape",
    fill: "#70B8CB",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e34f6e756a6c08ef6567f62c5c5c8b29.svg";
export { ForwardRef as ReactComponent };